<template>
  <div class="col-md-12" v-if="this.$store.state.cartCount" id="cartAlertId" >
    <div class="bg-success card mb-3 text-white">
      <div class="card-body d-flex justify-content-between align-items-center">
        <div class="mr-0 mr-md-5 d-flex align-items-center">
          <i style="font-size: 60px" class="fas fa-shopping-cart mx-3"></i>
          <div class="text-center text-md-start">
            <p class="fs-5">سبد خرید</p>
            <div class="fs-5">
              <span>تعداد اقلام :</span>
              <span>{{ this.$store.state.cartCount }}</span>
            </div>
            <div class="fs-5">
              <span>مجموع خرید :</span>
              <span>{{ this.utils.monize(this.$store.state.cartAmount) }} تومان</span>
            </div>
          </div>
        </div>

        <router-link 
            class="bg-white btn btn-rounded text-success" 
            :to="{name:'Cart'}"
            >
            <i class="fas fa-eye"></i>
            مشاهده سبد خرید
        </router-link>
        
      </div>
    </div>
  </div>
</template>
<script>
import utils from "../../libs/utils";

export default {
  name: "CartAlert",
  created() {
    this.utils = new utils();
  },
};
</script>